<template>
  <section class="section">
    <div>
      <div style="text-align: center; font-weight: bold; margin-bottom: 15px">
        {{ $l("components.server.updateServer", "Update server") }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="stepper-wrapper">
          <div
            class="stepper-item"
            :class="{
              active: step === 1,
              completed: step === 2 || step === 3,
            }"
          >
            <div class="step-counter"></div>
            <div class="step-name">
              {{ $l("components.server.basic", "Basic") }}
            </div>
          </div>
          <div
            class="stepper-item"
            :class="{
              active: step === 2,
              completed: step === 3,
            }"
          >
            <div class="step-counter"></div>
            <div class="step-name">
              {{ $l("components.server.quotas", "Quotas") }}
            </div>
          </div>

          <div
            class="stepper-item"
            :class="{
              active: step === 3,
            }"
          >
            <div class="step-counter"></div>
            <div class="step-name">
              {{
                $l(
                  "components.server.updateRepositories",
                  "Update repositoriess"
                )
              }}
            </div>
          </div>
        </div>
      </div>

      <div style="display: flex; justify-content: center">
        <box style="width: 85%">
          <div
            style="margin: auto; width: 95%; margin-top: 30px"
            v-if="step === 1"
          >
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label"
                    >{{ $l("components.server.serverName", "Server name") }}
                    <span style="color: red"> *</span></label
                  >
                </div>

                <div class="control">
                  <input
                    v-model="form.name"
                    type="text"
                    class="input"
                    :placeholder="
                      $l('components.server.enterName', 'Enter name')
                    "
                    :class="{ error: invalidName }"
                  />
                  <div v-if="invalidName" class="error-message">
                    {{
                      form.name.length === 0
                        ? $l(
                            "components.server.cannotBeLeftBlank",
                            "Cannot be left blank"
                          )
                        : $l(
                            "components.server.invalidNameFormat",
                            "Invalid name format"
                          )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label"
                    >{{ $l("components.server.fingerprint", "Identifier") }}
                    <span style="color: red"> *</span></label
                  >
                </div>

                <div class="control">
                  <input
                    v-model="form.fingerprint"
                    type="text"
                    class="input"
                    style="
                      cursor: not-allowed;
                      pointer-events: none;
                      opacity: 0.5;
                    "
                  />
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.email", "Email")
                  }}</label>
                </div>

                <div class="control">
                  <input
                    v-model="form.email"
                    type="text"
                    class="input"
                    placeholder="contact@cyradar.com"
                    :class="{ error: invalidEmail }"
                  />

                  <div v-if="invalidEmail" class="error-message">
                    {{
                      $l(
                        "components.server.invalidEmailFormat",
                        "Invalid email format"
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.phoneNumber", "phoneNumber")
                  }}</label>
                </div>

                <div class="control">
                  <input
                    v-model="form.phone_number"
                    type="text"
                    class="input"
                    placeholder="(+84) 24 7300 6066"
                    :class="{ error: invalidPhoneNumber }"
                  />
                  <div v-if="invalidPhoneNumber" class="error-message">
                    {{
                      $l(
                        "components.server.invalidPhoneNumberFormat",
                        "Invalid phone number format"
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.address", "Address")
                  }}</label>
                </div>

                <div class="control">
                  <input
                    v-model="form.address"
                    type="text"
                    class="input"
                    :placeholder="
                      $l(
                        'components.server.addressPlaceholder',
                        '9th Floor, FPT Tower, 10 Pham Van Bach street, Cau Giay District, Ha Noi'
                      )
                    "
                  />
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.company", "Company")
                  }}</label>
                </div>

                <div class="control">
                  <input
                    v-model="form.company"
                    type="text"
                    class="input"
                    :placeholder="
                      $l(
                        'components.server.companyPlaceholder',
                        'CyRadar Information Security Joint Stock Company'
                      )
                    "
                  />
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.description", "Desciption")
                  }}</label>
                </div>

                <div class="control">
                  <textarea
                    class="textarea"
                    :placeholder="
                      $l('components.server.description', 'Description')
                    "
                    v-model="form.description"
                  ></textarea>
                </div>
              </div>
            </div>

            <div slot="footer" class="field is-grouped is-grouped-right">
              <div class="control">
                <button class="button" @click.prevent="handleClickClose">
                  {{ $l("global.cancel", "Cancel") }}
                </button>
              </div>

              <div class="control">
                <button
                  class="button is-info"
                  @click.prevent="handleClickNext"
                  :class="{
                    'is-static':
                      invalidName ||
                      invalidEmail ||
                      invalidPhoneNumber ||
                      !form.name,
                  }"
                >
                  {{ $l("global.next", "Next") }}
                </button>
              </div>
            </div>
          </div>

          <div
            style="
              margin: auto;
              width: 95%;
              min-height: 600px;
              margin-top: 30px;
            "
            v-if="step === 2"
          >
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.numberOfAgents", "Number of agents")
                  }}</label>
                </div>

                <div class="control">
                  <input
                    v-model="form.agentLimit"
                    type="text"
                    class="input"
                    :placeholder="
                      $l('components.server.numberOfAgents', 'Number of agents')
                    "
                    :class="{ error: invalidAgentLimit }"
                  />
                  <div v-if="invalidAgentLimit" class="error-message">
                    {{
                      $l(
                        "components.server.greaterOrEqualZero",
                        "Quantity must be greater than or equal to 0"
                      )
                    }}
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l(
                      "components.server.numberOfEDRChildServers",
                      "Number of EDR child servers"
                    )
                  }}</label>
                </div>

                <div class="control">
                  <input
                    v-model="form.serverLimit"
                    type="text"
                    class="input"
                    :placeholder="
                      $l(
                        'components.server.numberOfEDRChildServers',
                        'Number of EDR child servers'
                      )
                    "
                    :class="{ error: invalidServerLimit }"
                  />
                  <div v-if="invalidServerLimit" class="error-message">
                    {{
                      $l(
                        "components.server.greaterOrEqualZero",
                        "Quantity must be greater than or equal to 0"
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l("components.server.expiredAt", "Expiration date")
                  }}</label>
                </div>

                <div class="control has-icons-right">
                  <date-picker :value.sync="form.expiredAt" />
                  <span class="icon is-small is-right">
                    <svg-icon type="mdi" :path="path"></svg-icon>
                  </span>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">{{
                    $l(
                      "components.server.numberOfEDRChildLevels",
                      "Number of EDR child levels"
                    )
                  }}</label>
                </div>

                <div class="control">
                  <v-select
                    v-model="form.treeheight"
                    :clearable="false"
                    :options="listTreeHeights"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div
              slot="footer"
              class="field is-grouped is-grouped-right"
              style="position: relative; top: 350px"
            >
              <div class="control">
                <button class="button" @click.prevent="handleClickStep(1)">
                  {{ $l("global.back", "Back") }}
                </button>
              </div>

              <div class="control">
                <button
                  class="button is-info"
                  @click.prevent="handleClickNext"
                  :class="{
                    'is-static': invalidAgentLimit || invalidServerLimit,
                  }"
                >
                  {{ $l("global.next", "Next") }}
                </button>
              </div>
            </div>
          </div>

          <div
            style="margin: auto; width: 95%; margin-top: 10px"
            v-if="step === 3"
          >
            <div slot="header">
              <div class="columns is-vcentered">
                <div class="column">
                  <p style="font-size: 14px; font-weight: bold">
                    <span>{{
                      $l("components.server.total", "Total") + " "
                    }}</span>
                    <span>{{ listSelectedTags.length }}</span>
                    <span>{{
                      " " +
                      $l(
                        "components.server.tagsToBeUpdated",
                        "tags to be updated"
                      )
                    }}</span>
                  </p>
                </div>
                <div class="column is-narrow">
                  <button
                    v-if="isAdmin"
                    class="button is-rounded is-small"
                    @click.prevent="showFormAddTag"
                  >
                    <i style="margin-top: 3px"
                      ><svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 0.5C7.44772 0.5 7 0.947715 7 1.5V7.5H1C0.447715 7.5 0 7.94772 0 8.5C0 9.05229 0.447715 9.5 1 9.5H7V15.5C7 16.0523 7.44772 16.5 8 16.5C8.55229 16.5 9 16.0523 9 15.5V9.5H15C15.5523 9.5 16 9.05229 16 8.5C16 7.94772 15.5523 7.5 15 7.5H9V1.5C9 0.947715 8.55229 0.5 8 0.5Z"
                          fill="#1672EC"
                        />
                      </svg> </i
                    >&ensp;&ensp;&ensp;&ensp;{{ $l("global.add", "Add") }}
                  </button>
                </div>
              </div>
            </div>

            <div style="margin-top: 20px">
              <data-table
                ref="table"
                :key="currentLocale"
                :items="listSelectedTags"
                :per-page="10"
                :sort-desc="true"
                :theme="$_ui_theme_tables"
              >
                <data-column
                  :sortable="false"
                  field="serial"
                  :label="$l('components.server.serial', 'No')"
                  width="7%"
                />

                <data-column
                  field="name"
                  :label="$l('components.server.name', 'Name')"
                  width="15%"
                >
                  <template #default="{ item }">
                    <div class="truncate">
                      {{ item.name }}
                    </div>
                  </template>
                </data-column>

                <data-column
                  field="description"
                  :label="$l('components.server.description', 'Description')"
                  width="35%"
                />

                <data-column :sortable="false" width="20%">
                  <template #default="{ item }">
                    <div class="actions-column-tags">
                      <span v-if="item.isDefault" class="tag">
                        {{
                          item.isDefault
                            ? $l("components.server.default", "Default")
                            : ""
                        }}
                      </span>
                      <Dropdown trigger="click" placement="bottom-start">
                        <span href="javascript:void(0)" style="cursor: pointer">
                          <octicon
                            :icon="kebabHorizontal"
                            label="kebabHorizontal"
                          />
                        </span>
                        <DropdownMenu slot="list">
                          <DropdownItem @click.native="deleteTag(item)">
                            <span style="color: red">{{
                              $l("components.server.delete", "Delete")
                            }}</span></DropdownItem
                          >
                          <div class="divider"></div>
                          <DropdownItem @click.native="setDefault(item)">
                            <span style="color: green">{{
                              $l("components.server.setDefault", "Set Default")
                            }}</span>
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </template>
                </data-column>
              </data-table>
            </div>

            <div slot="footer" class="field is-grouped is-grouped-right">
              <div class="control">
                <button class="button" @click.prevent="handleClickStep(2)">
                  {{ $l("global.back", "Back") }}
                </button>
              </div>

              <div class="control">
                <button
                  class="button is-info"
                  @click.prevent="handleClickComplete"
                  :class="{ 'is-static': listSelectedTags.length === 0 }"
                >
                  {{ $l("global.complete", "Complete") }}
                </button>
              </div>
            </div>
          </div>
        </box>
      </div>

      <modal :show.sync="formModal.formAddTag.isFormOpen">
        <box style="min-height: 150px">
          <div
            class="close-icon"
            @click="formModal.formAddTag.isFormOpen = false"
          >
            <i
              ><svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.8947 9.64035L8.25472 6.00033L11.8947 2.35934C11.965 2.28903 12.0044 2.1937 12.0044 2.09433C12.0044 1.99495 11.965 1.89962 11.8947 1.82931L10.1747 0.10934C10.1043 0.0393582 10.009 8.69931e-05 9.90975 8.69931e-05C9.81045 8.69931e-05 9.71517 0.0393582 9.64473 0.10934L6.00472 3.75033L2.3647 0.110316C2.32675 0.0725754 2.28105 0.0436068 2.23073 0.0253555C2.16302 -0.000966921 2.08908 -0.00695617 2.01802 0.00814363C1.94696 0.0232434 1.88186 0.058736 1.8307 0.110316L0.110734 1.82931C0.075842 1.86406 0.0481432 1.90542 0.0292519 1.95089C0.0103605 1.99637 0.000626377 2.04508 0.000626377 2.09433C0.000626377 2.14357 0.0103605 2.19228 0.0292519 2.23776C0.0481432 2.28323 0.075842 2.32459 0.110734 2.35934L3.75069 6.00033L0.110734 9.64035C0.0729259 9.67844 0.0436174 9.72414 0.0247353 9.77438C-0.00120613 9.84222 -0.00688891 9.91614 0.00837784 9.98715C0.0236446 10.0582 0.0592024 10.1231 0.110734 10.1743L1.8307 11.8933C1.86545 11.9282 1.90675 11.9559 1.95223 11.9748C1.9977 11.9937 2.04648 12.0034 2.09572 12.0034C2.14496 12.0034 2.19374 11.9937 2.23921 11.9748C2.28469 11.9559 2.32598 11.9282 2.36073 11.8933L6.00069 8.25338L9.64174 11.8933C9.67649 11.9282 9.71778 11.9559 9.76326 11.9748C9.80874 11.9937 9.85745 12.0034 9.90669 12.0034C9.95594 12.0034 10.0047 11.9937 10.0502 11.9748C10.0957 11.9559 10.137 11.9282 10.1717 11.8933L11.8917 10.1743C11.9433 10.1231 11.9788 10.0582 11.9941 9.98715C12.0094 9.91614 12.0037 9.84222 11.9777 9.77438C11.9597 9.72441 11.9314 9.67874 11.8947 9.64035Z"
                  fill="#666666"
                />
              </svg>
            </i>
          </div>
          <div class="columns">
            <div class="column">
              <div class="control">
                <v-select
                  v-model="formModal.formAddTag.value"
                  label="name"
                  :clearable="false"
                  :selectable="
                    (option) =>
                      !listSelectedTags.find((tag) => tag.id === option.id)
                  "
                  :options="listTags"
                >
                </v-select>
              </div>
            </div>

            <div class="column" style="margin-top: 10px; margin-left: 100px">
              <div class="control">
                <switches
                  v-model="formModal.formAddTag.value.isDefault"
                  type-bold="false"
                  theme="custom"
                  color="blue"
                ></switches>

                <span style="position: relative; top: -16px; left: 5px">{{
                  $l("components.server.default", "Default")
                }}</span>
              </div>
            </div>
          </div>

          <div
            slot="footer"
            class="field is-grouped is-grouped-right"
            style="margin-right: 80px"
          >
            <div class="control">
              <button
                class="button"
                @click.prevent="formModal.formAddTag.isFormOpen = false"
              >
                {{ $l("global.close", "Close") }}
              </button>
            </div>

            <div class="control">
              <button
                class="button is-info"
                @click.prevent="handleClickSubmitFormAddTag"
              >
                {{ $l("global.submit", "Submit") }}
              </button>
            </div>
          </div>
        </box>
      </modal>
    </div>
  </section>
</template>

<script>
import vSelect from "vue-select";
import { DatePicker, DataTable, DataColumn, Modal } from "@cyradar/ui";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiCalendarRange, mdiLightbulbFluorescentTubeOutline } from "@mdi/js";
import { customAlphabet } from "nanoid";
import ServerApi from "@/api/Server";
import UpdateApi from "@/api/Update";

import { mapGetters } from "vuex";
import { plus, kebabHorizontal } from "octicons-vue";
import Switches from "vue-switches";
import { Dropdown, DropdownMenu, DropdownItem, Checkbox } from "iview";

export default {
  components: {
    vSelect,
    DatePicker,
    SvgIcon,
    DataTable,
    DataColumn,
    Modal,
    Switches,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Checkbox,
  },

  data() {
    return {
      localStorageKey: "",
      path: mdiCalendarRange,
      plus,
      kebabHorizontal,
      step: 1,
      form: {},
      listTreeHeights: [0, 1, 2, 3, 4, 5],
      listSelectedTags: [],
      listTags: [],
      formModal: {
        formAddTag: {
          isFormOpen: false,
          value: {
            name: "",
            id: "",
            description: "",
            isDefault: null,
          },
        },
      },
    };
  },

  computed: {
    ...mapGetters(["authenticationClaims", "isAdmin", "currentLocale"]),

    invalidName() {
      const regex = /^(?!.*\s)[a-zA-Z0-9._-]{3,256}$/;

      return !regex.test(this.form.name);
    },

    invalidEmail() {
      if (this.form.email === "" || this.form.email === undefined) {
        return false;
      } else {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return !regex.test(this.form.email);
      }
    },

    invalidPhoneNumber() {
      if (
        this.form.phone_number === "" ||
        this.form.phone_number === undefined
      ) {
        return false;
      } else {
        const regex = /^0\d{9}$/;
        return !regex.test(this.form.phone_number);
      }
    },

    invalidAgentLimit() {
      if (
        parseInt(this.form.agentLimit) >= 0 ||
        this.form.agentLimit === "Unlimit"
      ) {
        return false;
      }
      return true;
    },

    invalidServerLimit() {
      if (parseInt(this.form.serverLimit) >= 0) {
        return false;
      }
      return true;
    },
  },

  methods: {
    generateUniqueId() {
      const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      const nanoid = customAlphabet(alphabet, 5);

      const segments = [nanoid(), nanoid(), nanoid(), nanoid(), nanoid()];
      return segments.join("-");
    },

    newFingerprint() {
      this.form.fingerprint = this.generateUniqueId();
    },

    handleClickStep(step) {
      if (this.step === step) {
        return;
      }

      if (step === 1) {
        this.step = 1;
      } else {
        if (step === 2) {
          this.step = 2;
        } else {
          if (step === 3) {
            this.step = 3;
          }
        }
      }
    },

    handleClickClose() {
      this.$router.replace({ name: "server" });
    },

    handleClickNext() {
      if (this.step === 1) {
        this.step++;
      } else {
        if (this.step === 2) {
          this.step++;
        }
      }
    },

    async fetchTags() {
      await UpdateApi.getTagList(this.$http).then((data) => {
        let tags = data;
        this.listTags = tags.map((tag) => {
          return {
            name: tag.name,
            id: tag._id,
            description: tag.description,
            isDefault: false,
          };
        });
      });

      this.setForm();
    },

    showFormAddTag() {
      this.formModal.formAddTag.isFormOpen = true;
      this.formModal.formAddTag.value = {
        name: "",
        id: "",
        description: "",
        isDefault: null,
      };
    },

    handleClickSubmitFormAddTag() {
      if (
        !this.listSelectedTags.find(
          (item) => item.id === this.formModal.formAddTag.value.id
        )
      ) {
        if (this.formModal.formAddTag.value.isDefault) {
          this.listSelectedTags.map((item) => (item.isDefault = false));
        }

        const value = {
          serial: this.listSelectedTags.length + 1,
          ...this.formModal.formAddTag.value,
        };

        this.listSelectedTags.push(value);
      }

      this.formModal.formAddTag.isFormOpen = false;
    },

    deleteTag(item) {
      this.listSelectedTags = this.listSelectedTags.filter(function (element) {
        return element.id !== item.id;
      });

      this.listSelectedTags.map(
        (element, index) => (element.serial = index + 1)
      );

      this.$refs.table.loadItems();
    },

    setDefault(item) {
      this.listSelectedTags.map((element) => (element.isDefault = false));
      this.listSelectedTags.find(
        (element) => element.id === item.id
      ).isDefault = true;

      this.$refs.table.loadItems();
    },

    handleClickComplete() {
      this.form.tags = this.listSelectedTags.map((element) => {
        return {
          id: element.id,
          isDefault: element.isDefault,
        };
      });

      this.updateServer();
    },

    updateServer() {
      const sendingForm = {
        ...this.form,
        expiredAt: this.form.expiredAt.toISOString(),
        agentLimit: !parseInt(this.form.agentLimit)
          ? -1
          : parseInt(this.form.agentLimit),
        serverLimit: parseInt(this.form.serverLimit),
        status: JSON.parse(
          localStorage.getItem(`serverInfor/${this.$route.params.id}`)
        ).status,
        lastConnection: JSON.parse(
          localStorage.getItem(`serverInfor/${this.$route.params.id}`)
        ).lastConnection,
      };

      ServerApi.updateServer(this.$http, sendingForm).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });

        this.$router.replace({
          name: "server",
        });
      });
    },

    renderTagName(val) {
      const x = this.listTags.find((tag) => tag.id === val);
      if (!x) {
        return;
      }

      return x.name;
    },

    setForm() {
      const formTemp = JSON.parse(
        localStorage.getItem(`serverInfor/${this.$route.params.id}`)
      );
      this.form = {
        ...formTemp,

        expiredAt: new Date(
          formTemp.expiredAt
        ),

        agentLimit:
        formTemp.agentLimit === -1
            ? "Unlimit"
            : formTemp.agentLimit,
      };

      this.listSelectedTags = JSON.parse(
        localStorage.getItem(`serverInfor/${this.$route.params.id}`)
      ).tags.map((item, i) => {
        return {
          id: item.id,
          isDefault: item.isDefault,
          name: this.renderTagName(item.id),
          description: item.description,
          serial: i + 1,
        };
      });
    },
  },

  mounted() {
    this.fetchTags();
    this.localStorageKey = `serverInfor/${this.$route.params.id}`;
  },

  beforeDestroy() {
    localStorage.removeItem(this.localStorageKey);
  },
};
</script>

<style src="vue-select/dist/vue-select.css"></style>

<style lang="scss" scoped>
@import "assets/app.scss";

.get-fingerprint {
  &:hover {
    opacity: 0.5;
  }

  position: absolute;
  z-index: 99;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

.actions-column-tags {
  display: flex !important;
  justify-content: flex-end !important;

  .menu-button:hover {
    cursor: pointer;
    opacity: 0.5;
  }

  .tag {
    background-color: #208b24;
    color: #c6f2c7;
    font-weight: 900;

    @include responsive(large-desktop) {
      width: 100px;
      height: 30px;
      font-size: 16px;
      margin-right: 70px;
    }

    @include responsive(desktop) {
      width: 80px;
      height: 20px;
      font-size: 14px;
      margin-right: 50px;
    }

    @include responsive(tablet) {
      margin-right: 30px;
    }

    @include responsive(mobile) {
      margin-right: 30px;
    }
  }
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

/deep/ button.modal-close {
  display: none;
}
</style>
